import { ReactNode } from 'react';

type ConditionalProviderProps = {
  condition: boolean;
  provider: (props: { children: ReactNode }) => ReactNode;
  children: ReactNode;
};

export const ConditionalProvider = ({ condition, provider: Provider, children }: ConditionalProviderProps) => {
  return condition ? <Provider>{children}</Provider> : <>{children}</>;
};
